<flx-heading size="'medium" align="center" weight="extra-light" type="creation">
	Customer Details
</flx-heading>
<div class="customer-details-container">
	<form [formGroup]="bf.bigForm" *ngIf="bf.bigForm.get('client_details')">
		<flx-flex-container direction="row" justifyContent="center">
			<!-- customer details -->
			@if (showCustomerDetails) {
			<flx-panel density="cozy" formGroupName="client_details" margin="8">
				@for (field of customerFields; track field.controlName) {
					<flx-label>{{ field.label | fsToHuman }}</flx-label>
					@if (field.type === 'dropdown') {
						<flx-dropdown
							[itemsOption]="resolveOptions(field)"
							[displayOptions]="{ displayKey: field.displayKey ?? 'display', valueKey: field.valueKey ?? 'value' }"
							[formControlName]="field.controlName"
							[placeHolder]="field.placeholder ?? ''"
							[searchEnabled]="false"
							(itemsSelected)="handleDropdownSelect(field, $event)"
						>
						</flx-dropdown>
					} @else {
						<flx-input-text [formControlName]="field.controlName" type="text" size="normal"></flx-input-text>
					}
					<flx-reactive-form-error-display [control]="getControl('client_details', field.controlName)"> </flx-reactive-form-error-display>
				}
			</flx-panel>
			}
			<!-- contact details -->
			@if (showContactDetails) {
			<flx-panel density="cozy" formGroupName="contact_details" margin="8">
				@for (field of contactFields; track field.controlName) {
					<flx-label>{{ field.label | fsToHuman }}</flx-label>
					@if (field.type === 'dropdown') {
						<flx-dropdown
							[itemsOption]="resolveOptions(field)"
							[displayOptions]="{ displayKey: field.displayKey ?? 'display', valueKey: field.valueKey ?? 'value' }"
							[formControlName]="field.controlName"
							[placeHolder]="field.placeholder ?? ''"
							[searchEnabled]="false"
							(itemsSelected)="handleDropdownSelect(field, $event)"
						>
						</flx-dropdown>
					} @else {
						<flx-input-text [formControlName]="field.controlName" type="text" size="normal"></flx-input-text>
					}
					<flx-reactive-form-error-display [control]="getControl('contact_details', field.controlName)"> </flx-reactive-form-error-display>
				}
			</flx-panel>
			}
			<!-- address details -->
			@if (showAddressDetails) {
			<flx-panel density="cozy" formGroupName="insured_address" margin="8">
				@for (field of addressCommonFields; track field.controlName) {
					<flx-label>{{ field.label | fsToHuman }}</flx-label>
					@if (field.type === 'dropdown') {
						<flx-dropdown
							[itemsOption]="resolveOptions(field)"
							[displayOptions]="{ displayKey: field.displayKey ?? 'display', valueKey: field.valueKey ?? 'value' }"
							[formControlName]="field.controlName"
							[placeHolder]="field.placeholder ?? ''"
							[searchEnabled]="false"
							(itemsSelected)="handleDropdownSelect(field, $event)"
						>
						</flx-dropdown>
					} @else {
						<flx-input-text
							[formControlName]="field.controlName"
							type="text"
							size="normal"
							[noEndingSpace]="field.inputProps?.noEndingSpace"
						></flx-input-text>
					}
					<flx-reactive-form-error-display [control]="getControl('insured_address', field.controlName)"> </flx-reactive-form-error-display>
				}
			</flx-panel>
			}
		</flx-flex-container>
	</form>
</div>
